export default __webpack_public_path__ + "static/media/rocket_anim_105.d71e607c.png";